import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=1f2a738a&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=1f2a738a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a738a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2a738a')) {
      api.createRecord('1f2a738a', component.options)
    } else {
      api.reload('1f2a738a', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=1f2a738a&scoped=true&", function () {
      api.rerender('1f2a738a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gE1Q67ct3146/JS/comp/Voucher.vue"
export default component.exports